import { getI18n } from "@vixi/localization";

export const minErrorMsg = (length: number | bigint) => () => {
  const { t, tNum } = getI18n();

  return {
    message: `${t("ErrorMessage.Min.MinimumOf")} ${tNum(length)} ${t("ErrorMessage.Min.CharactersRequired")}`,
  };
};
